/* @flow */

import UnderlyingDataAction from "./UnderlyingDataAction";
import UnderlyingRecordsAction from "./UnderlyingRecordsAction";

export const DEFAULT_ACTIONS = [UnderlyingDataAction, UnderlyingRecordsAction];



// WEBPACK FOOTER //
// ./qb/components/actions/index.js